import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Loader2, Crown } from "lucide-react";

export default function Register() {
  const { register, error, setError } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const ok = await register(name, email, password);
    setBusy(false);
    if (ok) nav("/dashboard");
  };

  return (
    <div className="min-h-screen grid place-items-center px-4 py-12 grain">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <span className="w-8 h-8 grid place-items-center rounded-md bg-gradient-to-br from-[var(--gold)] to-[#8a6b12] text-[#0a0a0e]">
            <Crown size={16} strokeWidth={2.5} />
          </span>
          <span className="font-display text-2xl tracking-widest">GET RIGHT</span>
        </Link>
        <div className="gr-card p-7 md:p-9">
          <div className="eyebrow">New member</div>
          <h1 className="font-display text-3xl uppercase mt-2 mb-6">Get on the list</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs uppercase font-mono tracking-widest text-[var(--gold)]">Name</label>
              <input
                data-testid="register-name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="mt-2 w-full bg-[var(--bg-elevated)] border border-[var(--border-subtle)] focus:border-[var(--border-gold)] outline-none rounded-lg px-3 py-2.5 text-sm"
              />
            </div>
            <div>
              <label className="text-xs uppercase font-mono tracking-widest text-[var(--gold)]">Email</label>
              <input
                data-testid="register-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full bg-[var(--bg-elevated)] border border-[var(--border-subtle)] focus:border-[var(--border-gold)] outline-none rounded-lg px-3 py-2.5 text-sm"
              />
            </div>
            <div>
              <label className="text-xs uppercase font-mono tracking-widest text-[var(--gold)]">Password</label>
              <input
                data-testid="register-password"
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 w-full bg-[var(--bg-elevated)] border border-[var(--border-subtle)] focus:border-[var(--border-gold)] outline-none rounded-lg px-3 py-2.5 text-sm"
              />
            </div>
            {error && (
              <div data-testid="register-error" className="text-sm text-[var(--danger)]">
                {error}
              </div>
            )}
            <button
              data-testid="register-submit"
              disabled={busy}
              className="gr-btn-gold w-full py-3 rounded-full text-sm inline-flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {busy && <Loader2 className="animate-spin" size={16} />}
              Create account
            </button>
          </form>
          <div className="mt-5 text-sm text-[var(--text-secondary)] text-center">
            Already in?{" "}
            <Link to="/login" className="gold-text hover:underline" data-testid="register-goto-login">
              Sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
